import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';
import { LocalizationPreferencesModel } from '@nimbus-library/features/user-settings/models/localization-preferences.model';

@Injectable()
export abstract class LocalizationPreferencesApiClient {
  protected abstract readonly preferencesResource: string;

  public constructor(protected readonly baseHttpService: BaseHttpService) {}

  public get(userId: string, tenantId: string): Observable<LocalizationPreferencesModel> {
    return this.baseHttpService.get(this.url(userId, tenantId));
  }

  public save(userId: string, tenantId: string, preferences: LocalizationPreferencesModel): Observable<LocalizationPreferencesModel> {
    return this.baseHttpService.put(this.url(userId, tenantId), preferences);
  }

  private url(userId: string, tenantId: string): string {
    return `user-settings/v1/userSettings/${encodeURIComponent(userId)}/${encodeURIComponent(tenantId)}/${this.preferencesResource}`;
  }
}
